module.exports = __webpack_public_path__ + "media/assets/images/blog/pipeline-assistenza-small-eddc464672bb7d3aded657076566ae34.jpg";